import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) { }

  obtenerDashboard(): Observable<any> {
    return this.http.get<any>(environment.API_SECURITY + '/dashboard')
  }

  obtenerDashboardConFiltro(filtroVentas?: string): Observable<any> {
    let url = environment.API_SECURITY + '/dashboard';
    if (filtroVentas) {
      url += `?filtroVentas=${filtroVentas}`;
    }
    return this.http.get<any>(url);
  }

  alertas(): Observable<any> {
    return this.http.get<any>(environment.API_SECURITY + '/reportes/alertas')
  }


}
